import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Icon from 'shared/components/Icon'
import Button from 'shared/components/Button/Button'

import './styles.scss?global'

const InProgress = ({ t, closeHandler, description, buttonText, customHeader, iconName, redirectLink }) =>
  <div className='in-progress'>
    <Icon type={iconName || 'meditator-balls'} />
    {customHeader
      ? <h2>{customHeader}</h2>
      : <h1>{t('wait').s}<span>{t('time').s}</span></h1>
    }
    <h3>{description || ''}</h3>
    {redirectLink
      ? <div style={{'width': '100%', 'text-decoration': 'underline', 'text-align': 'left'}} onClick={closeHandler}>{redirectLink}</div>
      : null
    }
    <Button view={'transparent-red'} onClick={closeHandler}>
      {buttonText}
    </Button>
  </div>

InProgress.propTypes = {
  t: PropTypes.func,
  closeHandler: PropTypes.func,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  customHeader: PropTypes.string,
  iconName: PropTypes.string,
  redirectLink: PropTypes.string // TODO: remove later when it's not needed anymore. TREP-1255
}

function mapStateToProps (state) {
  return {
    t: state.i18n.get('app', 'views', 'MarketPlace', 'InProgress')
  }
}

export default connect(mapStateToProps)(InProgress)
